import React, { useState, useEffect, useMemo, useCallback } from "react";
import { Redirect } from "react-router-dom";
//import Breadcrumbs
import Breadcrumbs from "../../components/Common/Breadcrumb";

import {
    Button,
    Card,
    Col,
    Container,
    Row,
    Spinner
} from "reactstrap";
import _ from "lodash";
import dayjs from "dayjs";
import { getDashboardBranches, getDashboardStatus } from "../../helpers/backend_helper";
import SummaryBar from "./SalidasStatus/SummaryBar";
import RamalRow from "./SalidasStatus/RamalRow";
import SalidaDetailModal from "./SalidasStatus/SalidaDetailModal";
import { buildRamal, buildTotals, ESTADOS, GAP_HUECO, GAP_OBJETIVO, GAP_PEGADAS } from "./SalidasStatus/statusHelper";
import { getStorageUser } from "../../helpers/api_helper";
import { PROFILES } from "../../components/VerticalLayout/SidebarContent";
import "./SalidasStatus/SalidasStatus.css";

const DashboardSalidas = () => {
    document.title = "Inicio Salidas | Sistema de Logística";

    // /dashboard-salidas esta en la whitelist de App.js, asi que el operador puede llegar
    // tecleando la URL; este tablero es de toda la ruta y no le corresponde.
    // El guard va antes de cualquier hook para no romper el orden de hooks.
    if (getStorageUser().profile_id === PROFILES.Operador) {
        return <Redirect to="/dashboard" />
    }

    const [loading, setLoading] = useState(false)
    const [initialized, setInitialized] = useState(false)
    const [branchLines, setBranchLines] = useState([])
    const [status, setStatus] = useState({})
    const [nextSalidas, setNextSalidas] = useState(null)
    const [corte, setCorte] = useState(null)
    const [stale, setStale] = useState(false)
    const [sort, setSort] = useState("severidad")
    const [filtro, setFiltro] = useState("todos")
    const [selectedId, setSelectedId] = useState(null)

    const getBranches = async () => {
        const response = await getDashboardBranches({})
        const branches = _.orderBy(response?.branches ?? [], ['name'], ['asc']);
        setBranchLines(branches)
    }

    const getStatus = useCallback(async () => {
        setLoading(true)
        try {
            const response = await getDashboardStatus({ withToast: false })
            // Aqui `status` es el objeto de KPIs del endpoint, no la bandera del
            // sentinel de error de api_helper: solo se acepta si es un objeto.
            if (response?.status && typeof response.status === 'object') {
                setStatus(response.status)
                setNextSalidas(response.next_salidas ?? null)
                setCorte(response.today ?? dayjs().format('YYYY-MM-DD HH:mm:ss'))
                setStale(false)
            } else {
                setStale(true)
            }
        } catch (error) {
            console.error(error)
            setStale(true)
        }
        setLoading(false)
        setInitialized(true)
    }, [])

    useEffect(() => {
        getBranches()
        getStatus()
        const interval = setInterval(() => {
            getStatus()
        }, 1000 * 60 * 1)
        return () => clearInterval(interval);
    }, [getStatus])

    const allRows = useMemo(
        () => (branchLines || []).map((branch, index) => buildRamal(branch, status?.[branch.id] ?? [], index)),
        [branchLines, status]
    )

    const totals = useMemo(() => buildTotals(allRows), [allRows])

    const ramalesConQuemadas = useMemo(() => allRows.filter((r) => r.counts.que > 0), [allRows])

    const rows = useMemo(() => {
        const filtered = filtro === "quemadas" ? ramalesConQuemadas : allRows
        return sort === "severidad"
            ? _.orderBy(filtered, ["sev", "nombre"], ["desc", "asc"])
            : filtered
    }, [allRows, ramalesConQuemadas, filtro, sort])

    // La unidad del modal se refresca con cada consulta; si deja de estar activa el modal se cierra
    const selectedUnit = useMemo(
        () => totals.all.find((u) => u.id === selectedId) ?? null,
        [totals, selectedId]
    )

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    {/* Render Breadcrumbs */}

                    <Row>
                        <Col xl="12">
                            <Card className="salidas-status-card">
                                <div className="salidas-status-header">
                                    <div>
                                        <div style={{ fontSize: "15px", fontWeight: 600, lineHeight: 1.2 }}>Estatus Salidas</div>
                                        <div style={{ fontSize: "11px", color: "#777a89", marginTop: 2 }}>
                                            {allRows.length} ramales · se actualiza cada minuto
                                        </div>
                                    </div>
                                    {corte && (
                                        <div
                                            className="d-flex align-items-center"
                                            style={{
                                                gap: 7,
                                                padding: "5px 11px 5px 9px",
                                                background: stale ? ESTADOS.rie.bg : ESTADOS.tie.bg,
                                                border: `1px solid ${stale ? ESTADOS.rie.bd : ESTADOS.tie.bd}`,
                                                borderRadius: 100,
                                            }}
                                        >
                                            <span
                                                style={{
                                                    width: 7,
                                                    height: 7,
                                                    borderRadius: "50%",
                                                    background: stale ? ESTADOS.rie.color : ESTADOS.tie.color,
                                                    boxShadow: stale ? "none" : "0 0 0 3px rgba(60,209,136,.25)",
                                                }}
                                            />
                                            <span style={{ fontSize: "11px", fontWeight: 600, color: stale ? ESTADOS.rie.ink : "#1d6b47" }}>
                                                {stale ? "Sin actualizar" : "En vivo"}
                                            </span>
                                            <span style={{ fontSize: "11px", color: stale ? ESTADOS.rie.ink : "#33795a" }}>
                                                · corte {dayjs(corte).format("HH:mm:ss")}
                                            </span>
                                        </div>
                                    )}
                                    <div style={{ flex: 1 }} />
                                    <div className="salidas-status-segmented">
                                        <button type="button" className={filtro === "todos" ? "active" : ""} onClick={() => setFiltro("todos")}>
                                            Todos <span className="opacity-75">· {allRows.length}</span>
                                        </button>
                                        <button type="button" className={filtro === "quemadas" ? "active" : ""} onClick={() => setFiltro("quemadas")}>
                                            Con quemadas <span className="opacity-75">· {ramalesConQuemadas.length}</span>
                                        </button>
                                    </div>
                                    <div className="salidas-status-segmented">
                                        <button type="button" className={sort === "severidad" ? "active" : ""} onClick={() => setSort("severidad")}>
                                            Por severidad
                                        </button>
                                        <button type="button" className={sort === "ramal" ? "active" : ""} onClick={() => setSort("ramal")}>
                                            Por ramal
                                        </button>
                                    </div>
                                    <Button color="light" size="sm" onClick={getStatus} disabled={loading}>
                                        {loading
                                            ? <Spinner size="sm" className="me-1" />
                                            : <i className="mdi mdi-refresh me-1"></i>}
                                        Actualizar
                                    </Button>
                                </div>

                                <SummaryBar totals={totals} />

                                <div className="salidas-status-rows">
                                    {!initialized && (
                                        <div className="text-center py-5">
                                            <Spinner color="primary" />
                                        </div>
                                    )}
                                    {initialized && rows.length === 0 && (
                                        <div className="text-center text-muted py-5" style={{ fontSize: "12px" }}>
                                            {filtro === "quemadas" ? "Ningún ramal tiene salidas quemadas." : "No hay ramales configurados."}
                                        </div>
                                    )}
                                    {initialized && rows.map((row) => (
                                        <RamalRow
                                            key={row.id}
                                            row={row}
                                            // false = no hay mas salidas hoy; undefined = el backend no envio el dato
                                            nextSalida={nextSalidas ? (nextSalidas[row.id] ?? false) : undefined}
                                            selectedId={selectedId}
                                            onSelect={setSelectedId}
                                        />
                                    ))}
                                </div>

                                <div className="salidas-status-legend">
                                    <span style={{ fontSize: "10.5px", letterSpacing: ".07em", textTransform: "uppercase", color: "#777a89", fontWeight: 600 }}>
                                        Cinta bajo el recorrido = hueco entre unidades
                                    </span>
                                    <span className="d-flex align-items-center" style={{ gap: 7 }}>
                                        <span style={{ width: 22, height: 12, borderRadius: 3, background: ESTADOS.que.bg, border: `1px solid ${ESTADOS.que.bd}` }} />
                                        Pegadas (&lt;{GAP_PEGADAS}′)
                                    </span>
                                    <span className="d-flex align-items-center" style={{ gap: 7 }}>
                                        <span style={{ width: 22, height: 12, borderRadius: 3, background: ESTADOS.tie.bg, border: `1px solid ${ESTADOS.tie.bd}` }} />
                                        Intervalo sano
                                    </span>
                                    <span className="d-flex align-items-center" style={{ gap: 7 }}>
                                        <span style={{ width: 22, height: 12, borderRadius: 3, background: ESTADOS.rie.bg, border: `1px solid ${ESTADOS.rie.bd}` }} />
                                        Hueco (&gt;{GAP_HUECO}′)
                                    </span>
                                    <span style={{ color: "#495057" }}>
                                        · objetivo {GAP_OBJETIVO}′ · el ancho del bloque es la distancia real entre las dos unidades
                                    </span>
                                    <div style={{ flex: 1 }} />
                                    <span style={{ color: "#495057" }}>
                                        “Atraso prom.” = promedio de minutos de las salidas atrasadas del ramal · ◆ = punto de retorno · clic en una unidad para ver su detalle
                                    </span>
                                </div>
                            </Card>
                            <SalidaDetailModal unit={selectedUnit} onClose={() => setSelectedId(null)} />
                        </Col>
                    </Row>

                </Container>
            </div>
        </React.Fragment>
    );
}
export default DashboardSalidas;
